import { render, staticRenderFns } from "./MultipleChoiceImageDashboardItem.vue?vue&type=template&id=5629cd17&scoped=true"
import script from "./MultipleChoiceImageDashboardItem.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceImageDashboardItem.vue?vue&type=script&lang=js"
import style0 from "./MultipleChoiceImageDashboardItem.vue?vue&type=style&index=0&id=5629cd17&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5629cd17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5629cd17')) {
      api.createRecord('5629cd17', component.options)
    } else {
      api.reload('5629cd17', component.options)
    }
    module.hot.accept("./MultipleChoiceImageDashboardItem.vue?vue&type=template&id=5629cd17&scoped=true", function () {
      api.rerender('5629cd17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dashboard/Items/MultipleChoiceImageDashboardItem.vue"
export default component.exports